<template>
  <div>
    <div class="box">
      <el-form ref="form" :model="queryData" class="form">
        <el-form-item>
          <el-input placeholder="请输入用户名" v-model="queryData.userName"></el-input>
        </el-form-item>
        <!--<el-form-item class="item">
          <el-select filterable allow-create default-first-option v-model="queryData.agentId" placeholder="请选择代理商">
            <el-option label="请选择" value="-1"></el-option>
            <el-option v-for="item in agentList" :label="item.agentName" :value="item.agentId" :key="item.id"></el-option>
          </el-select>
        </el-form-item>-->
        <el-form-item>
          <el-button plain type="primary" size="small" icon="el-icon-search" @click="onSubmit(1)" style="margin-left:10px">搜索</el-button>
          <el-button plain type="primary" size="small" icon="el-icon-plus" @click="Hdialog">新增用户</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table ref="multipleTable" :data="tableData" :row-style="{height:'40px',textAlign:'center'}"
              :cell-style="{height:'5px,0',textAlign:'center'}"
              :header-cell-style="{background:'#f8f8f9',color:'#333',textAlign:'center'}"
              border style="width: 100%;margin-top: 1%;margin-bottom: 60px;height: 70vh">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column prop="id" label="id" width="220">
      </el-table-column>
      <el-table-column prop="accountName" label="账户" width="220">
      </el-table-column>
      <el-table-column prop="roleId" label="角色" >
        <template slot-scope="{row}">
          <span v-if="row.roleId==='772'">用户</span>
          <span v-if="row.roleId==='771'">管理员</span>
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="用户名" width="220">
      </el-table-column>
      <el-table-column prop="agentId" label="代理商" width="220">
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" width="220">
      </el-table-column>
      <el-table-column label="操作" min-width="220">
        <template slot-scope=" scope">
          <el-button v-if="scope.row.agentId!=='zy0000'" type="primary" size="small" plain @click.native="deleteUser(scope.row.id)">删除用户</el-button>
          <el-button type="primary" size="small" plain @click.native="resetPassword(scope.row.id)">重置密码</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination class="text-center" ref="pagination" v-bind:list="onSubmit" v-bind:itemCount="8"></pagination>

    <!-- 新增弹窗 -->
    <el-dialog class="class_dialog_hospital" title="新增用户" :visible.sync="dialogFormVisible" width="40%" :close-on-click-modal="false">
      <el-form :model="formAdd" :rules="rules" ref="formAdd" label-width="20%">
        <el-form-item label="账户" prop="userName">
          <el-input style="width:70% " placeholder="请输入账户" v-model="formAdd.userName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input style="width:70%" placeholder="请输入密码" v-model="formAdd.password" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="代理商选择" prop="agentId">
          <el-select @focus="loadAgent" filterable allow-create default-first-option v-model="formAdd.agentId" placeholder="请选择代理商" style="width:70%">
            <el-option label="代理商选择" value=""></el-option>
            <el-option v-for="item in agentList" :key="item.id" :label="item.agentName" :value="item.agentId">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-select  v-model="formAdd.roleId" placeholder="请选择角色" style="width:70%">
            <el-option v-if="formAdd.agentId==='zy0000'"  label="流量池管理端" value="771"></el-option>
            <el-option v-if="formAdd.agentId!=='zy0000'"  label="流量池代理端" value="772"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户名" prop="accountName">
          <el-input style="width:70%" placeholder="请输入用户名" v-model="formAdd.accountName" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" plain type="primary" @click="Hnew('formAdd')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 新增弹窗结束 -->

    <!-- 修改密码 -->
    <!--<el-dialog title="修改密码" width="30%" :visible.sync="modifyPassword">
      <el-form label-width="100px">
        <el-form-item label="账户" required>
          <el-input v-model="username"></el-input>
        </el-form-item>
        <el-form-item label="原始密码" required>
          <el-input v-model="password"></el-input>

        </el-form-item>
        <el-form-item label="新密码" required>
          <el-input v-model="newpassword"></el-input>

        </el-form-item>
        <el-form-item label="确认密码" required>
          <el-input v-model="conpassword"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="modifyPassword = false">取 消</el-button>
        <el-button type="primary" @click="changePassword()">确 定</el-button>
      </div>

    </el-dialog>-->
    <!-- 修改密码结束 -->

    <!-- 重置密码 -->
    <el-dialog title="重置密码" :visible.sync="redifyPassword" width="30%">
      <div style="">
        <el-input  v-model="cid" readonly></el-input>
      </div>
      <div style="color: red" class="reset form">
        <!--<span style="width:60%;margin-top:10px"> 重置密码：</span>-->
        <el-input v-model="repassword" placeholder="请输入重置密码"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" size="small"  @click="redifyPassword=false">取消</el-button>
        <el-button type="primary" size="small" plain @click="resetPassworded(cid)">确定</el-button>
      </div>
    </el-dialog>
    <!-- 重置密码结束 -->
  </div>
</template>

<script>
import Pagination from '../../../components/pagination.vue'
export default {
  name: 'Addnew',
  components: {
    Pagination
  },
  data() {
    return {
      reSetPasswordId: '',
      agentList: [],
      form: {
        userName: '',
        password: '',
        roleId: '',
        accountName: '',
        roleName: ''
      },
      formAdd: {
        userName: '',
        roleId: '',
        password: '',
        accountName: '',
        agentId: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 1, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请选择密码', trigger: 'blur' },
          { min: 3, max: 15, message: '长度在 3 到 15 个字符', trigger: 'blur' }
        ],
        roleId: [{ required: true, message: '请选择角色', trigger: 'change' }],
        agentId: [{ required: true, message: '请选择代理', trigger: 'change' }],
        accountName: [
          { required: true, message: '请输入账户', trigger: 'blur' },
          { min: 2, max: 15, message: '长度在 2 到 15 个字符', trigger: 'blur' }
        ]
      },
      queryData: {
        userName: '',
        agentId: '',
        current: 1,
        size: 10
      },
      roles: [],
      dialogFormVisible: false,
      modifyPassword: false, //修改密码
      redifyPassword: false, //重置密码
      password: '',
      newpassword: '',
      conpassword: '',
      username: '',
      repassword: '',
      tableData: [],
      poolJs: require('../../../api/pool'),
      agentJs: require('../../../api/agent'),
      cid:''
    }
  },

  methods: {
    loadAgent(){
      this.agentJs.getSearchAgent(
              {}).then(res=>{
        res.data.data.map(item=>{
          let map={
            agentId: item.agentId,
            agentName: item.agentName
          }
          this.agentList.push(map)
        })

      })
    },
    // 点击新增用户
    Hdialog() {
      this.dialogFormVisible = true
      this.formAdd = {}
    },
    // 点击搜索
    onSubmit(page) {
      let _this = this
      _this.queryData.currentPage = page
      _this.queryData.size = _this.$refs.pagination.size
      _this.poolJs.findUser(_this.queryData).then(response => {
        _this.$refs.pagination.render(page, response.data.data.total)
        _this.tableData = response.data.data.rows
      })
    },
    // 点击新增用户
    Hnew(formAdd) {
      this.$refs[formAdd].validate(valid => {
        if (valid) {
          this.dialogFormVisible = false
          this.poolJs.addUser(this.formAdd).then(response => {
            this.$alert(response.data.msg)
            this.roles = []
          })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },

    // 删除用户
    deleteUser(id) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.poolJs.delUser(id).then(response => {
          if (response.data.code !== '0') {
            this.$alert(response.data.msg)
          }else {
            this.onSubmit(1)
          }
        })
      })
    },
    // 修改密码
    openPassword() {
      this.modifyPassword = true
    },
    // 修改密码点击确认
    changePassword() {
      if (this.password === '') {
        this.$swal('请输入原密码')
        return false
      }
      if (this.newpassword === '') {
        this.$swal('请输入新密码')
        return false
      }
      if (this.conpassword === '') {
        this.$swal('请输入确认密码')
        return false
      }
      if (this.newpassword !== _this.conpassword) {
        this.$swal('两次密码输入不正确')
        return false
      }
    },
    // 重置密码
    resetPassword(id) {
      this.cid = id
      this.redifyPassword = true
    },
    //重置密码确认
    resetPassworded() {
      let that=this
      that.redifyPassword = false
      if (that.$check.checkIsNull(that.repassword)) {
        this.$alert('请输入需要重置的密码')
        return false
      }
      let map={
        id: that.cid,
        password: that.repassword
      }
      this.poolJs.resetPassword(map)
        .then(response => {
          if (response.data.code==='0') {
            this.$alert(response.data.data)
          } else {
            this.$alert(response.data.msg)
          }
        })
        .catch(() => {
        })
    },

  },
  mounted() {
    this.$axios.get('/queryAgentList').then(response => {
      this.agentList = response.data.data
    })
  }
}
</script>

<style lang="less" scoped>

  /* 设置滚动条宽度和高度 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar {
    width: 10px; /* 横向滚动条 */
    height: 10px; /* 纵向滚动条 必写 */
  }
  /* 设置滚动条样式 */
  ::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #dde;
    border-radius: 3px;
  }
  ::v-deep .el-table {
    height: 88%;
    .el-table__body-wrapper {
      height: calc(100% - 48px) !important; // 表格高度减去表头的高度
      overflow-y: auto;
    }
  }

.contain {
  position: relative;
  padding: 20px;
  background: #fff;
  border-radius: 5px;
}
.box {
  width: 100%;
  border-radius: 10px;
  margin-top: 20px;
}

.form {
  display: flex;
  margin-bottom: -10px;
  margin-top: 10px;
}

.item {
  margin-left: 10px;
}


.but {
  font-size: 14px;
  margin-left: 30px;
}

h1 {
  text-align: center;
  font-weight: 700;
  font-size: 30px;
}
/deep/ .el-input__inner {
  height: 35px;
}
.text-center {
  position: absolute;
  bottom: 10px;
  right: 0px;
}
</style>
<style lang="less" scoped>
/deep/.el-table td,
.el-table th {
  padding: 0px;
}
</style>
<style lang="less">
.el-table td,
.el-table th {
  padding: 0px !important;
}
thead.has-gutter {
  height: 40px;
}
</style>
